// @ts-nocheck
export const TTS_ACL_MODULE = 'TTS';
export const TTS_OPERATOR_SARVAM = 'SARVAM';
export const TTS_OPERATOR_OMNI = 'OMNI_VOICE';
export const DEFAULT_TTS_OPERATOR = TTS_OPERATOR_OMNI;

export function isTtsOperatorConfigured(entry) {
  return entry?.tts_operator != null;
}

export function formatTtsOperatorLabel(entry) {
  const op = entry?.tts_operator;
  if (!op) return '—';
  return op === TTS_OPERATOR_OMNI ? 'OMNI VOICE' : 'SARVAM';
}

export function normalizeTtsOperatorForSave(operator) {
  return operator === TTS_OPERATOR_SARVAM ? TTS_OPERATOR_SARVAM : TTS_OPERATOR_OMNI;
}

export function getTtsAllowedLanguages(moduleOperations) {
  try {
    const ops = typeof moduleOperations === 'string' ? JSON.parse(moduleOperations) : moduleOperations;
    const langs = ops?.[TTS_ACL_MODULE]?.allowed_languages;
    return Array.isArray(langs) && langs.length > 0 ? langs : null;
  } catch {
    return null;
  }
}
